import {combineReducers} from 'redux-immutable';

import dialogReducer from '../../dialog/reducer';
import treeReducer from '../tree/reducer';
import Cart from './component';
import mainReducer from './reducer';


export const initialState = {};
const _reducer = combineReducers({
    main: mainReducer,
    regionTree: treeReducer,
    cityTree: treeReducer,
    infoDialog: dialogReducer,
});
export const reducer = (state, action) => {
    if (!state.get('main')) {
        state = state.set('main', mainReducer(undefined, {}));
    }
    return _reducer(state, action);
};
export const component = Cart;
export const eNamad = true;
